import React from 'react';
import PropTypes from "prop-types";
import Profile from './Profile';
import {connect} from 'react-redux';
import {
    Button,
    Components,
    ConfirmationButton,
    InputInformation,
    InputList,
    MaskType,
    PopupWindow,
    SelectInput,
    ValidationEngine,
    validationEngineFromInputInformationList,
    ValidationRules,
    ValidationStyle,
    ValidationType
} from 'dts-react-common';
import {disableUI, dispatchUpdateData, PAGES} from '../common/Shared';
import Inputmask from 'inputmask';
import webservice, {ajaxStatusCore} from '../app/Webservice';
import validator from 'validator';
import NoOfferFound from "../common/NoOfferFound";
import {dispatchField} from "../common/Dispatch";
import AjaxSpinner from "dts-react-common/components/ajax-spinner/AjaxSpinner";
import moment, {duration} from "moment";

const propTypes = {
    history: PropTypes.object.isRequired,
    offer: PropTypes.object,
    rejectionReason: PropTypes.array.isRequired
};

const defaultProps = {
    offer: undefined,
};

const mapStateToProps = (state) => {
    return {
        offer: state.app.offer,
        rejectionReason: state.dataList.rejectionReason,
    };
};

const socialMask = {
    inputMask: new Inputmask('999-99-9999', {
        placeholder: '***-**-****',
        clearMaskOnLostFocus: false,
        autoUnmask: false
    }),
};

class OfferAcceptance extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showSocial: false,
            showRejectOffer: false,
            isAcceptPressed: false,
            isSubmitPressed: false,
            isRejectPressed: false,
            passwordMatching: true,
            rejectReason: undefined,
            displaySpinner: false,
            newestBirthdate: moment().subtract(14, 'years').format("MM/DD/YYYY"),
            oldestBirthdate: moment().subtract(120, 'years').format("MM/DD/YYYY"),
        };

        this.acceptOffer = this.acceptOffer.bind(this);
        this.rejectOffer = this.rejectOffer.bind(this);
        this.closeRejectOffer = this.closeRejectOffer.bind(this);
        this.validateBirthdate = this.validateBirthdate.bind(this);
        this.getInvalidBirthdateError = this.getInvalidBirthdateError.bind(this);

        this.dispatchPromise = (payload) => new Promise((resolve, reject) => {
            resolve(dispatchUpdateData(payload));
        });

        this.inputs = [
            new InputInformation({
                field: 'electronicSignature',
                label: "Signature",
                placeholder: "Full Name",
                type: Components.TEXT_INPUT,
                className: "stack-form mr-spacing",
                validationTypes: [ValidationType.REQUIRED],
                size: 'size-large',
            })
        ];

        this.inputs.forEach(input => {
            input.onChange = (field, value) => dispatchUpdateData({path: 'app.offer', field: field, value: value});
        });

        this.validationEngine = validationEngineFromInputInformationList(this.inputs);

        this.socialInputs = [
            new InputInformation({
                field: 'socialSecurityNumber',
                label: "Social Security Number",
                type: Components.TEXT_INPUT,
                className: "stack-form",
                validationTypes: [
                    ValidationType.REQUIRED,
                    ValidationRules[ValidationType.IS_LENGTH]({min: 9, max: 11}),
                    ValidationRules[ValidationType.CUSTOM_CALLBACK](data => data.match(/^\d{3}-\d{2}-\d{4}$/), () => 'Must be in the format ###-##-####'),
                ],
                maskType: socialMask
            }),
            new InputInformation({
                field: 'birthDate',
                label: 'Birth Date',
                type: Components.CALENDAR_INPUT,
                className: "stack-form",
                validationTypes: [
                    ValidationType.REQUIRED,
                    ValidationRules[ValidationType.CUSTOM_CALLBACK]((data) => this.validateBirthdate(data), (data) => this.getInvalidBirthdateError(data)),
                ],
            }),
            new InputInformation({
                field: 'password',
                label: "Password",
                type: Components.TEXT_INPUT,
                className: "stack-form",
                validationTypes: [ValidationType.REQUIRED, ValidationRules[ValidationType.CUSTOM_CALLBACK](data => validator.isLength(data, {min: 8}), data => `Must be at least 8 characters`, ValidationType.IS_LENGTH)],
                typeOfInput: "password"
            }),
            new InputInformation({
                field: 'passwordConfirm',
                label: "Confirm Password",
                type: Components.TEXT_INPUT,
                className: "stack-form",
                validationTypes: [ValidationType.REQUIRED, ValidationRules[ValidationType.CUSTOM_CALLBACK](data => validator.isLength(data, {min: 8}), data => `Must be at least 8 characters`, ValidationType.IS_LENGTH)],
                typeOfInput: "password"
            })
        ];

        this.socialInputs.forEach(input => {
            input.onChange = (field, value) => dispatchUpdateData({path: 'app.offer', field: field, value: value});
        });

        this.validationEngineSocial = validationEngineFromInputInformationList(this.socialInputs);

        this.validationEngineReject = new ValidationEngine({'hiringStatusFk': [ValidationType.REQUIRED]});
        this.validationEngineReject.setValidationStyle(ValidationStyle.BLURRED);

    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    acceptOffer() {
        if (this.props.offer.password === this.props.offer.passwordConfirm) {
            webservice.offer
                .save(this.props.offer)
                .then(offer => {
                    this.setState({showSocial: false});
                    this.setState({displaySpinner: true});
                    return offer;
                })
                .then(offer => webservice.offer.accept(offer))
                .then(() => webservice.offer.get(this.props.offer.guid))
                .then(offer => {
                    dispatchField('app.offer', offer);
                    this.setState(
                        {
                            showSocial: false,
                            isSubmitPressed: false,
                            passwordMatching: false
                        }, () => this.dispatchPromise([
                            {path: 'app', field: 'accepted', value: true}
                        ]).then(this.props.history.push(`/${PAGES.FIRST_DAY}/${this.props.offer.guid}`))
                    );
                })
                .catch(() => this.setState({showSocial: false}))
                .finally(() => this.setState({displaySpinner: false}));

        } else {
            this.setState({passwordMatching: false});
        }
    }

    rejectOffer() {
        webservice.offer.reject(this.props.offer).then(() => {
            dispatchUpdateData({path: 'app', field: 'rejected', value: true});
            this.setState({showRejectOffer: false, isRejectPressed: false});
        });
    }

    closeRejectOffer() {
        this.setState({showRejectOffer: false, isRejectPressed: false}, () => dispatchUpdateData({
            path: 'app.offer',
            field: 'hiringStatusFk',
            value: null
        }));
    }

    validateBirthdate(date) {
        let myDate = null;

        if ((date.length !== 10) || (date.indexOf("M") !== -1)  || (date.indexOf("D") !== -1)  || (date.indexOf("Y") !== -1)) {
            return false;
        }

        myDate = moment(date, ["MM/DD/YYYY"]);
        if (!myDate.isValid()) {
            return false;
        }

        if (moment(myDate, ["MM/DD/YYYY"]).isAfter(moment(this.state.newestBirthdate, ["MM/DD/YYYY"]))) {
            return false;
        }

        if (moment(myDate, ["MM/DD/YYYY"]).isBefore(moment(this.state.oldestBirthdate, ["MM/DD/YYYY"]))){
            return false;
        }

        return true;
    }


    getInvalidBirthdateError(date) {
        let myDate = null;
        // console.log('getInvalidBirthdateError date: ', date);

        if ((date && date.length !== 10) || (date && date.indexOf("M") !== -1)  || (date && date.indexOf("D") !== -1)  || (date && date.indexOf("Y") !== -1)) {
            return "Invalid...";
        }

        myDate = moment(date, ["MM/DD/YYYY"]);
        if (!myDate.isValid()) {
            return "Invalid";
        }

        if (moment(myDate, ["MM/DD/YYYY"]).isAfter(moment(this.state.newestBirthdate, ["MM/DD/YYYY"]))) {
            return `Minimum age is 14. Enter birth >= ${this.state.newestBirthdate}`;
        }

        if (moment(myDate, ["MM/DD/YYYY"]).isBefore(moment(this.state.oldestBirthdate, ["MM/DD/YYYY"]))){
            return `Maximum age is 120. Enter birth <= ${this.state.oldestBirthdate}`;
        }

        return null;
    }

    render() {
        this.state.isAcceptPressed ? this.validationEngine.setValidationStyle(ValidationStyle.ALWAYS) : this.validationEngine.setValidationStyle(ValidationStyle.BLURRED);
        this.state.isSubmitPressed ? this.validationEngineSocial.setValidationStyle(ValidationStyle.ALWAYS) : this.validationEngineSocial.setValidationStyle(ValidationStyle.BLURRED);
        this.state.isRejectPressed ? this.validationEngineReject.setValidationStyle(ValidationStyle.ALWAYS) : this.validationEngineReject.setValidationStyle(ValidationStyle.BLURRED);
        this.inputs.map(input => input.disabled = disableUI());
        if (this.props.offer && this.props.offer.guid) {
            this.validationEngine.isValid(this.props.offer);
            this.validationEngineSocial.isValid(this.props.offer);
            this.validationEngineReject.isValid(this.props.offer);
            // this.loadDates();
        }
        return (
            <React.Fragment>
                {this.props.offer && this.props.offer.guid ?
                    <div>
                        <Profile/>
                        <section className="mb-spacing">
                            <h2 className="headline">Offer Acceptance</h2>
                            <div className="content">
                                <p><strong>Please enter your name as it appears on your Social Security Card and select
                                    "Accept Offer."</strong></p>
                                <p>This is only the first step of the offer acceptance process. Within one day of
                                    completing
                                    these steps, you will receive another email asking you to complete two onboarding
                                    tours.
                                    Please follow the instructions in the second email to complete the offer acceptance
                                    process.</p>
                                <div>
                                    <InputList inputs={this.inputs} data={this.props.offer}
                                               validationEngine={this.validationEngine}/>
                                </div>
                                <div className="flex">
                                    <Button
                                        label="Accept Offer"
                                        onClick={() => this.validationEngine.isValid(this.props.offer) ? this.setState({
                                            showSocial: true,
                                            isAcceptPressed: true
                                        }) : this.setState({isAcceptPressed: true})}
                                        className="button mr-spacing"
                                        disabled={disableUI()}
                                    />
                                    <Button
                                        label="Reject Offer"
                                        onClick={() => {
                                            dispatchUpdateData({path: 'app.offer', field: 'hiringStatusFk', value: ''});
                                            this.setState({showRejectOffer: true});
                                        }}
                                        className="button mr-spacing danger"
                                        disabled={disableUI()}
                                    />
                                </div>
                                {this.state.displaySpinner ?
                                    <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/> : undefined}
                            </div>
                        </section>

                        {this.state.showSocial ? <PopupWindow
                            onCloseButtonCallback={() => this.setState({showSocial: false})}
                            className="popup-window--large"
                            footerChildren={(
                                <div className="message-popup__footer--single">
                                    <Button
                                        label="Cancel"
                                        onClick={() => this.setState({showSocial: false})}
                                        className="button button--solid complementary mr-spacing"
                                    />
                                    <Button
                                        label="Save"
                                        onClick={() => {
                                            this.setState({isSubmitPressed: true});
                                            this.validationEngineSocial.isValid(this.props.offer) ? this.acceptOffer() : undefined;
                                        }}
                                        className="button"
                                    />
                                </div>
                            )}>
                            <h2>Complete the Offer Acceptance Process</h2>
                            <p>To complete the offer acceptance process, please enter your <em>Social Security Number,
                                Birth
                                Date</em> and a default <em>password</em> to login to your new employee account on your
                                first day at work.</p>
                            <p>This is only the first step of the offer acceptance process. Please enter your Social
                                Security Number and a default password to login to your new employee account on your
                                first
                                day of work. By tomorrow you will receive another email asking you to complete two
                                onboarding tours. Please follow the instructions in the second email to complete the
                                offer
                                acceptance process.</p>
                            <InputList inputs={this.socialInputs} data={this.props.offer}
                                       validationEngine={this.validationEngineSocial}/>
                            <p className="italic">* required</p>
                            {this.state.isSubmitPressed && !this.state.passwordMatching ?
                                <p className="alert-danger">The password confirmation does not match.</p> : undefined}
                            {ajaxStatusCore.isAjaxing() ?
                                <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/> : undefined}
                        </PopupWindow> : undefined}

                        {this.state.showRejectOffer ? <PopupWindow
                            onCloseButtonCallback={this.closeRejectOffer}
                            className="popup-window--large"
                            footerChildren={(
                                <div className="message-popup__footer--single">
                                    <Button
                                        label="Cancel"
                                        onClick={this.closeRejectOffer}
                                        className="button button--solid complementary mr-spacing"
                                    />
                                    <ConfirmationButton
                                        initialLabel="Reject"
                                        promptLabel="Are you sure?"
                                        onConfirm={() => {
                                            this.setState({isRejectPressed: true});
                                            if (this.validationEngineReject.isValid(this.props.offer)) {
                                                this.rejectOffer();
                                            }
                                        }}
                                        className="button danger"
                                    />
                                </div>
                            )}>
                            <h2>You are about to reject this offer</h2>
                            <p>You will reject an offer of employment
                                for <strong>{this.props.offer.workingTitle}</strong> with
                                the {this.props.offer.agencyName}.
                                Please select your primary reason for rejecting this offer:</p>
                            <SelectInput
                                field="hiringStatusFk"
                                label="Reject reason"
                                showLabel={false}
                                options={this.props.rejectionReason}
                                showSearch={false}
                                allowClear={false}
                                value={this.props.offer.hiringStatusFk}
                                onChange={(field, value) => dispatchUpdateData({
                                    path: 'app.offer',
                                    field: field,
                                    value: value
                                })}
                                validationEngine={this.validationEngineReject}
                                setInitialFocus={true}
                                size="size-large"
                            />
                        </PopupWindow> : undefined}

                    </div> : <NoOfferFound/>}
            </React.Fragment>
        );
    }
}

OfferAcceptance.propTypes = propTypes;
OfferAcceptance.defaultProps = defaultProps;

export default connect(mapStateToProps)(OfferAcceptance);